import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from './AppIcon';
import { useServiceRequest } from './ServiceStatusProvider';

const CustomerNavigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { requestCleaning } = useServiceRequest();

  // 세탁 신청 메뉴는 접수 상태에 따라 폼 이동 또는 안내 모달로 분기합니다.
  const handleNavClick = (item, event) => {
    if (item?.path === '/cleaning-request-form') {
      event?.preventDefault();
      requestCleaning();
    }
  };

  const navigationItems = [
    { path: '/customer-home', label: '홈', icon: 'Home' },
    { path: '/cleaning-request-form', label: '서비스 신청', icon: 'ClipboardList' },
    { path: '/before-after', label: '비포&애프터', icon: 'Image' },
    { path: '/price-guide', label: '가격 안내', icon: 'DollarSign' },
    { path: '/order-status-tracking', label: '주문 조회', icon: 'Package' },
    { path: '/terms-and-conditions', label: '이용약관', icon: 'FileText' },
  ];

  const isActive = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <header className="sticky top-0 z-50 w-full bg-card shadow-card">
        <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <Link to="/customer-home" className="flex items-center space-x-2">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
                <img src="/assets/images/logo.png" alt="SNEAKER CARE 로고" className="h-8 w-8 object-contain" />
              </div>
              <span className="text-xl font-extrabold text-foreground" style={{ fontFamily: "'Baloo 2', cursive" }}>SNEAKER CARE</span>
            </Link>

            <div className="hidden md:flex md:items-center md:space-x-1">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  onClick={(e) => handleNavClick(item, e)}
                  className={`flex items-center space-x-2 rounded-md px-4 py-2 text-sm font-medium transition-all duration-150 ease-out hover:bg-muted ${
                    isActive(item?.path)
                      ? 'bg-primary text-primary-foreground'
                      : 'text-foreground'
                  }`}
                >
                  <Icon name={item?.icon} size={18} />
                  <span>{item?.label}</span>
                </Link>
              ))}
              <Link
                to="/admin-login"
                className="ml-2 rounded-md px-4 py-2 text-sm font-medium bg-primary text-primary-foreground transition-all duration-150 ease-out hover:bg-primary/90"
              >
                관리자
              </Link>
            </div>

            <button
              onClick={toggleMobileMenu}
              className="inline-flex items-center justify-center rounded-md p-2 text-foreground hover:bg-muted md:hidden"
              aria-label="메뉴 열기"
            >
              <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
            </button>
          </div>
        </nav>

        {isMobileMenuOpen && (
          <div className="border-t border-border md:hidden">
            <div className="space-y-1 px-4 pb-3 pt-2">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  onClick={(e) => {
                    handleNavClick(item, e);
                    setIsMobileMenuOpen(false);
                  }}
                  className={`flex items-center space-x-3 rounded-md px-3 py-2 text-base font-medium transition-all duration-150 ease-out ${
                    isActive(item?.path)
                      ? 'bg-primary text-primary-foreground'
                      : 'text-foreground hover:bg-muted'
                  }`}
                >
                  <Icon name={item?.icon} size={20} />
                  <span>{item?.label}</span>
                </Link>
              ))}
              <Link
                to="/admin-login"
                onClick={() => setIsMobileMenuOpen(false)}
                className="flex items-center space-x-3 rounded-md px-3 py-2 text-base font-medium bg-primary text-primary-foreground"
              >
                <Icon name="User" size={20} />
                <span>관리자</span>
              </Link>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default CustomerNavigation;